import { ColDef } from 'ag-grid-enterprise';

export type AuditTrailTableRow = {
  action: string;
  details: string;
  user: string;
  category: string;
  timestamp: string;
};

export const colDefsAuditTrailTable: ColDef<AuditTrailTableRow>[] = [
  {
    field: 'action',
    headerName: 'Action',
    sortable: true,
    filter: true,
    type: 'w200',
    autoHeight: true,
    cellClass: 'flex align-items-center justify-content-left',
    wrapText: true,
  },
  {
    field: 'details',
    headerName: 'Details',
    sortable: true,
    cellClass: 'flex align-items-center justify-content-left',
    type: 'w120',
    filter: true,
  },
  {
    field: 'user',
    headerName: 'User',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    type: 'w200',
    sortable: true,
    filter: true,
  },
  {
    field: 'category',
    headerName: 'Category',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    type: 'w200',
    sortable: true,
    filter: true,
  },
  {
    field: 'timestamp',
    headerName: 'Timestamp',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    type: 'w200',
    sortable: true,
    filter: true,
  },
];
